import gql from 'graphql-tag'

export const ADD_TEMPO = gql`
 mutation insert_tempo($id: uuid!,$name: String!,$platNo: String!,$city: String!, $capacity: bigint!, $kmLimit: bigint!,
 $contractorId: uuid!, $extraKmPrice: bigint!,$hiringPrice: bigint!, $status: Boolean, $type: String) {
  insert_tempo(objects: {id: $id, name: $name, platNo: $platNo, city: $city, capacity: $capacity, status: $status,
   kmLimit: $kmLimit, contractorId:$contractorId, extraKmPrice:$extraKmPrice, hiringPrice:$hiringPrice, type:$type}) {
    returning {
      id
 }
}
  }
`

export const UPDATE_TEMPO = gql`
 mutation ($tempoId: uuid!,$name: String!,$platNo: String!,$city: String!, $capacity: bigint!,
  $kmLimit: bigint!,$contractorId: uuid!,$extraKmPrice: bigint!,$hiringPrice: bigint!, $status: Boolean, $type: String) {
   update_tempo (where: {id: {_eq: $tempoId}}, _set: {name: $name, platNo: $platNo, city: $city,capacity: $capacity, status: $status,
    kmLimit: $kmLimit,contractorId:$contractorId,extraKmPrice:$extraKmPrice, hiringPrice:$hiringPrice, type:$type}) {
    returning {
      id
     }
    }
  }
`
export const DELETE_TEMPO = gql`
 mutation ($tempoId: uuid!) {
   delete_tempo(where: {id: {_eq: $tempoId}}) {
    returning {
      id
     }
    }
  }
`
export const ADD_TRUCK = gql`
 mutation insert_truck($id: uuid!,$name: String!,$platNo: String!,$routes: jsonb!, $capacity: bigint!, $kmLimit: bigint!,$transporterId: uuid!) {
  insert_truck(objects: {id: $id, name: $name, platNo: $platNo, routes: $routes, capacity: $capacity, kmLimit: $kmLimit, transporterId:$transporterId}) {
    returning {
      id
 }
}
  }
`

export const UPDATE_TRUCK = gql`
 mutation ($truckId: uuid!,$name: String!,$platNo: String!,$routes: jsonb!, $capacity: bigint!, $kmLimit: bigint!, $transporterId: uuid!) {
   update_truck (where: {id: {_eq: $truckId}}, _set: {name: $name, platNo: $platNo, routes: $routes, capacity: $capacity, kmLimit: $kmLimit, transporterId:$transporterId}) {
    returning {
      id
     }
    }
  }
`
export const DELETE_TRUCK = gql`
 mutation ($truckId: uuid!) {
   delete_truck(where: {id: {_eq: $truckId}}) {
    returning {
      id
     }
    }
  }
`

export const ADD_DRIVER = gql`
 mutation insert_driverDetails($id: uuid!,$name: String!,$mobile: String!,$proof: String!, $status: Boolean,
  $driverType: Int!, $contractorId: uuid!, $transporterId: uuid!, $skipTransporter: Boolean!) {
insert_driverDetails(objects: {id: $id, name: $name, mobile: $mobile, proof: $proof, status: $status,
  driverType: $driverType, contractorId: $contractorId}) @include(if: $skipTransporter){
    returning {
      id
 }
}
insert_driverDetails(objects: {id: $id, name: $name, mobile: $mobile, proof: $proof, status: $status,
  driverType: $driverType, transporterId:$transporterId}) @skip(if: $skipTransporter){
    returning {
      id
 }
}
  }
`

export const UPDATE_DRIVER = gql`
 mutation ($driverId: uuid!,$name: String!,$mobile: String!,$proof: String!, $status: Boolean,
 $driverType: Int!, $contractorId: uuid!, $transporterId: uuid!, $skipTransporter: Boolean!) {
   update_driverDetails (where: {id: {_eq: $driverId}}, _set: {name: $name, mobile: $mobile, proof: $proof, status: $status,
   driverType: $driverType, contractorId: $contractorId})@include(if: $skipTransporter) {
    returning {
      id
     }
    }
    update_driverDetails (where: {id: {_eq: $driverId}}, _set: {name: $name, mobile: $mobile, proof: $proof, status: $status,
   driverType: $driverType, transporterId:$transporterId})@skip(if: $skipTransporter) {
    returning {
      id
     }
    }
  }
`
export const DELETE_DRIVER = gql`
 mutation ($driverId: uuid!) {
   delete_driverDetails(where: {id: {_eq: $driverId}}) {
    returning {
      id
     }
    }
  }
`
export const ADD_CONTRACTOR = gql`
 mutation insert_contractor($id: uuid!, $createdAt: timestamptz!, $name: String!,$mobile: bigint!,$email: String!,$monthlyKms: bigint!,$gstin: String!,$pan: String!,$city: String!,$contractorCode: String!) {
  insert_contractor(objects: {id: $id, createdAt: $createdAt, name: $name, mobile: $mobile, email: $email, monthlyKms:$monthlyKms, gstin:$gstin,pan:$pan,city:$city,contractorCode:$contractorCode }) {
    returning {
      id
 }
}
  }
`

export const INSERT_CONTRACTOR_WITH_ADDRESS = gql`
mutation insert_contractor($object: [contractor_insert_input!]!){
  insert_contractor(objects: $object) {
    returning{id}
  }
}
`

export const UPDATE_CONTRACTOR = gql`
 mutation ($contractorId: uuid!,$name: String!,$mobile: bigint!,$email: String!,$monthlyKms: bigint!,$gstin: String!,$pan: String!, $city: String!) {
   update_contractor (where: {id: {_eq: $contractorId}}, _set: {name: $name, mobile: $mobile, email: $email, monthlyKms:$monthlyKms, gstin:$gstin, pan:$pan, city:$city}) {
    returning {
      id
     }
    }
  }
`
export const UPDATE_CONTRACTOR_WITH_ADDRESS = gql`
mutation update_contractor($contractorId: uuid!, $contractorObj: contractor_set_input, $addressId: uuid!, $addressObj: contractorAddress_set_input) {
 update_contractor (
    where: {id: {_eq: $contractorId}}
    _set: $contractorObj
  ) {
    returning {
      id
     }
    }
    update_contractorAddress (
    where: {id: {_eq: $addressId}}
    _set: $addressObj
  ) {
    returning {
      id
     }
    }
  }
`
export const INSERT_ADDRESS_OF_CONTRACTOR = gql`
mutation insert_contractorAddress($object: [contractorAddress_insert_input!]!){
  insert_contractorAddress(objects: $object) {
    returning{id}
  }
}
`
export const UPDATE_CONTRACTOR_V2 = gql`
mutation update_contractor($contractorId: uuid!, $contractorObj: contractor_set_input) {
 update_contractor (
    where: {id: {_eq: $contractorId}}
    _set: $contractorObj
  ) {
    returning {
      id
     }
    }
  }
`
export const DELETE_CONTRACTOR = gql`
 mutation ($contractorId: uuid!) {
   delete_contractor(where: {id: {_eq: $contractorId}}) {
    returning {
      id
     }
    }
    delete_contractorAddress(where: {contractorId: {_eq: $contractorId}}) {
    returning {
      id
     }
    }
  }
`
